export default {"src":"/_next/static/media/mondial-logotype-black-rgb.c02e796d.svg","height":450,"width":450,"blurWidth":0,"blurHeight":0};